export const Routes = {
  Home: '/',
  CollectionDetail: '/collections/:slug',
  CityDetail: '/cities/:slug',
  PageDetail: '/pages/:slug',
  PageDetailEmbed: '/pages/:slug/embed',

  // Events
  EventsCalendar: '/events/calendar',
  EventDetail: '/events/:slug',
  EventCart: '/events/:slug/cart',
  EventInquiry: '/events/:slug/inquiries/:id',
  EventCheckout: '/events/:slug/checkout',
  EventCheckoutConfirmation: '/events/:slug/checkout/confirmation',

  // Lineup
  EventLineup: '/events/:slug/lineup',
  EventLineupView: '/events/:slug/lineup/:view',
  EventLineupKindView: '/events/:slug/lineup/:kind/:view',

  // Ticket Offers
  EventTicketOffer: '/offers/events/:slug/code/:code',

  // Transers
  AcceptTransfer: '/transfers/accept',

  // Account
  Account: '/account',
  AccountDetails: '/account/details',
  AccountFavoritesArtists: '/account/favorites/artists',
  AccountFavoritesEvents: '/account/favorites/events',
  AccountTickets: '/account/tickets',
  AccountTicketsDetail: '/account/tickets/:slug',
  AccountOnboarding: '/account/onboarding',

  // Saudi Rewards
  SaudiRewardsRetroRedeem: '/saudi-rewards/retro-redeem',

  // Misc
  Notfound: '/404',
  ApiExitPreview: '/api/exit-preview',
  PrivacyPolicy: '/privacy-policy',
  TermsOfService: '/terms-and-conditions',
  UnsupportedDevice: '/support/unsupported-device',

  // Auth
  Login: '/login',
  SsoCallback: '/auth/sso-callback',
  EmailLinkVerification: '/auth/email-link-verification',
  EmailLinkLoading: '/auth/email-link-loading',
  AuthenticateWebview: '/auth/webview',

  // The reason this doesn't start with a "/" is because it's used in the app redirect
  AppTicketDetails: 'tickets/:slug/:eventId/detail/:ticketId',
  AppTickets: 'account/tickets',

  // Store
  Store: '/store',
} as const;
